"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AzureDevopsGranularityRefusalCode = void 0;
/** Sent in `extensions.errors[*].code` when an ADO workstream granularity save is refused, so clients never read the error text. */
var AzureDevopsGranularityRefusalCode;
(function (AzureDevopsGranularityRefusalCode) {
    AzureDevopsGranularityRefusalCode["AzureDevopsGranularityColumnHasBlanks"] = "AzureDevopsGranularityColumnHasBlanks";
    AzureDevopsGranularityRefusalCode["AzureDevopsGranularityLocked"] = "AzureDevopsGranularityLocked";
    AzureDevopsGranularityRefusalCode["AzureDevopsGranularityOrganizationHostIdOnly"] = "AzureDevopsGranularityOrganizationHostIdOnly";
})(AzureDevopsGranularityRefusalCode || (exports.AzureDevopsGranularityRefusalCode = AzureDevopsGranularityRefusalCode = {}));
